export default "__VITE_ASSET__BhospzuG__"